// extracted by mini-css-extract-plugin
export var black = "_2g-6";
export var brand = "_2g-1";
export var ddefault = "_2g-0";
export var error = "_2g-3";
export var gray = "_2g-2";
export var highContrast = "_2g-8";
export var outline = "_2g-7";
export var success = "_2g-5";
export var warning = "_2g-4";